import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import Header from "./Header";
import {
  Userlogin,
  GetDealerdata,
  fetchDataFromApi,
  shareIphonePostMsg,
  handleGetApiGF,
  Toast,
  demoDeviceToken,
  isIOS,
  isWebView,
} from "./Utils/general-function";
import { useNavigate, Link } from "react-router-dom";
import Loader from "./Utils/Loader";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { RWebShare } from "react-web-share";
import styled from "styled-components";
import Profilerequired from "./Account/profilerequired";

// NEW IMAGES IMPORTED
import carinsurance from "../src_img/car-insurance.png";
import buycarimg from "../src_img/buying1.png";
import dayjs from "dayjs";
import { useNotificationPermisionReminder } from "../notification/useNotificationPermisionReminder";
const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  border-radius: 4px;
  font-family: "Rubik", sans-serif;
  padding: 3px 22px;
  font-size: 1rem;
  color: white;
  user-select: none;
  border: none;
  background-color: ${(props) => props.bgColor || "red"};
`;
const Dashboard = React.memo((props) => {
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [Banner, setBanner] = useState([]);
  const [count, setCount] = useState({
    Totalcars: 0,
    TotalUnsoldcars: 0,
    TotalSoldcars: 0,
    TotalCatelogecar: 0,
    TotalCarinCateloge: 0,
    UpdateNotification: [],
  });
  const [Dealerdata, setDealerdata] = useState({});
  const [customerCarCount, setCustomerCarCount] = useState({
    count: 0,
    isNewCarFromcusotmer: true,
  });
  useNotificationPermisionReminder();

  const navigate = useNavigate();
  const iphone = window.navigator.userAgent.includes("Mac");

  const fechCustomerCarCount = async () => {
    const res = await handleGetApiGF({
      url: "/api/Carmaster/Dashboardcounter",
    });

    if (!res?.succ) {
      Toast(false, "", res?.msg);
      return;
    }

    let lastcount = localStorage.getItem("customerCarCount");
    let isNewCarFromcusotmer = true;

    if (lastcount < res?.data?.Data?.TotalCustomercar || 0) {
      // when new car added
      isNewCarFromcusotmer = true;
    } else if (lastcount >= res?.data?.Data?.TotalCustomercar) {
      // when car deleted and udpaed count in local storage
      localStorage.setItem(
        "customerCarCount",
        res?.data?.Data?.TotalCustomercar,
      );
      isNewCarFromcusotmer = false;
    }
    setCustomerCarCount((prev) => ({
      ...prev,
      count: res?.data?.Data?.TotalCustomercar || 0,
      isNewCarFromcusotmer: isNewCarFromcusotmer,
    }));
  };

  useEffect(() => {
    fechCustomerCarCount();

    const fetchData = async () => {
      // below is third party notification script loading function
      // const loadScript = () => {
      //   return new Promise((resolve, reject) => {
      //     const existingScript = document.getElementById("gravitec-script");
      //     if (existingScript) {
      //       resolve(); // Script is already loaded
      //       return;
      //     }

      //     const script = document.createElement("script");
      //     script.src =
      //       "https://cdn.gravitec.net/storage/6504ce9788418d04e4fd16f071126219/client.js";
      //     script.async = true;
      //     script.id = "gravitec-script";
      //     script.onload = resolve;
      //     script.onerror = reject;
      //     document.head.appendChild(script);
      //   });
      // };

      try {
        if (!Userlogin()) {
          navigate("/Login");
          return;
        }
        // demoDeviceToken();
        //  document.body.style.background = 'linear-gradient(0deg, rgb(254,0,0) 0%, rgb(0,0,0) 100%)';

        const Dealerdata = await GetDealerdata();

        setDealerdata(Dealerdata);

        //   permissiontoggeled(Dealerdata.nPostpermission);
        localStorage.setItem("Permission", Dealerdata.nPostpermission);

        if (Dealerdata.nCity === "") {
          setShow(true);
        }

        // Fetching dashboard data
        const dashboardData =
          (await fetchDataFromApi("/api/Carmaster/Dashboardcounter")) || [];
        const count = {
          TotalCatelogecar: dashboardData.Data.TotalCatelogecar,
          TotalSoldcars: dashboardData.Data.TotalSoldcars,
          TotalUnsoldcars: dashboardData.Data.TotalUnsoldcars,
          Totalcars: dashboardData.Data.Totalcars,
          TotalCarinCateloge: dashboardData.Data.TotalCarinCateloge,
          UpdateNotification: dashboardData.Data.UpdatedNotificationlist,
          BoughtCarbymonth: dashboardData.Data.BoughtCarbymonth,
          SoldCarbymonth: dashboardData.Data.SoldCarbymonth,
        };
        setCount(count);

        // Fetch banner data
        const bannerData = await fetchDataFromApi(
          "/api/Bannermaster/AllBanner",
        );
        setBanner(bannerData.Data);
        // For Notification
        // if (!isIOS()) {
        //   await loadScript();
        // }

        setLoading(false);
      } catch (error) {
        console.error("An error occurred:", error);
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      const script = document.getElementById("gravitec-script");
      //   document.body.style.background = '';
      if (script) {
        document.head.removeChild(script);
      }
    };
  }, [navigate]);

  const onShare = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        let value = "";

        return (
          <div className="popup-overlay px-3 py-3">
            <div className="form-div">
              <label className="form-label">Mobile Number</label>
              <input
                type="text"
                className="form-control"
                name="mobileno"
                onChange={(e) => {
                  value = e.target.value;
                }}
              />
              {/* <span className="text-danger">{errors.name}</span> */}
            </div>
            <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                if (value !== "") {
                  const text = encodeURIComponent(
                    "https://m.carthi.in/#/Catlogueshare/" +
                      localStorage.getItem("Ca1itd") +
                      "/" +
                      encodeURIComponent(
                        localStorage
                          .getItem("Ca1nioamed")
                          ?.replace(/[,& . ']/g, ""),
                      ),
                  );

                  if (iphone) {
                    //return window.location.href = `https://wa.me/+91${value}?text=${text}`;

                    shareIphonePostMsg({
                      action: "open_url_linking",
                      url: `https://wa.me/+91${value}?text=${text}`,
                    });
                  } else {
                    // only work in android phone
                    //only for whatspp bussiness: window.location.href = `intent://send?phone=+91${value}&text=${text}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;end`;
                    window.location.href = `intent://send?phone=+91${value}&text=${text}#Intent;scheme=whatsapp;end`;
                  }
                  onClose();
                }
              }}
            >
              Send
            </button>
            {/* <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button> */}
          </div>
        );
      },
    });
  };

  const closemodel = () => {
    setShow(!show);
  };

  const permissiontoggeled = (status) => {
    const YesButton = document.getElementById("Allow");
    const NoButton = document.getElementById("Deny");
    if (status === "Allow") {
      YesButton.textContent = "Allowed";
      NoButton.textContent = "Deny";
    } else {
      // NoButton.textContent = "Denied";
      YesButton.textContent = "Allow";
    }
  };

  const permissionallowed = async (status) => {
    // social media car share permission
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
    };
    const Response = await fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/BrandingProfile/UpdatePostPermission?postpermission=" +
        status,
      header,
    );
    const Permission = await Response.json();
    if (Permission.Success) {
      localStorage.setItem("Permission", status);
      permissiontoggeled(status);
    }
  };

  const Poster = {
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    swipeToSlide: true,
    cssEase: "linear",
  };

  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}
      <div className="slider-section">
        <div className="slider-images">
          <Slider {...Poster}>
            {Banner.map((data) => (
              <Link to={data.nUrl} key={data.nPhoto}>
                <img src={data.nPhoto} alt="" />
              </Link>
            ))}
          </Slider>
        </div>
      </div>
      {count.UpdateNotification.length !== 0 && (
        <div className="latestbg">
          <marquee>
            {count.UpdateNotification.map((data) => (
              <div className="latestnews" key={data.nTitle}>
                <Link to="/AllUpdatedNotification">{data.nTitle}</Link>
              </div>
            ))}
          </marquee>
        </div>
      )}

      <div className="text-center" style={{ margin: "15px 15px 0 15px" }}>
        <div
          className="w-100"
          style={{ position: "relative", display: "inline-block" }}
        >
          <Link
            to="/customercarlist"
            state={{ carcount: customerCarCount?.count }}
            class="super-button"
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            }}
          >
            <span>{customerCarCount?.count}</span>Buy cars from customer direct
            <svg fill="none" viewBox="0 0 24 24" class="arrow">
              <path
                stroke-linejoin="round"
                stroke-linecap="round"
                stroke-width="2"
                stroke="currentColor"
                d="M5 12h14M13 6l6 6-6 6"
              ></path>
            </svg>
          </Link>
          {customerCarCount?.isNewCarFromcusotmer && (
            <div class="super-dot"></div>
          )}
        </div>
      </div>

      {/* buy car by heten bhai end */}
      {/* CARTHI INSURANCE */}
      <div
        className=" d-flex justify-content-between align-items-center pb-0 dash-grid"
        // style={{ margin: "15px 15px 0 15px" }}
      >
        <Link to="/carthiinsurance" className="w-100">
          <div className="dash-block py-2 px-2 d-flex justify-content-between align-items-center">
            <span>Carthi Insurance </span>
            <img src={carinsurance} width={38} alt="" />
          </div>
        </Link>
        <Link to="/carthifinance" className="w-100">
          <div className="dash-block py-2 px-2 d-flex justify-content-between align-items-center">
            <span>Carthi Finance</span>
            <img src="assets/images/car-unsold12.png" width={40} alt="" />
          </div>
        </Link>
      </div>
      <div>
        <div className="dash-grid">
          {/* dash count with rediirect */}
          <Link to="/MyCar">
            <div className="dash-block ">
              <span>My vehicles</span>
              <div className="d-flex justify-content-between align-items-center totalcar">
                <h3>{count.Totalcars}</h3>
                <img src="assets/images/car12.png" alt="" />
              </div>
            </div>
          </Link>
          <Link to={"/Catlogue/" + localStorage.getItem("Ca1itd")}>
            <div className="dash-block">
              <span>My catalog</span>
              <div className="d-flex justify-content-between align-items-center totalcar">
                <h3>{count.TotalCatelogecar}</h3>
                <img src="assets/images/catalogue12.png" alt="" />
              </div>
            </div>
          </Link>
          <Link to={"/Soldunsold"} state={{ status: "Sold" }}>
            <div className="dash-block ">
              <span>Sold vehicles</span>
              <div className="d-flex justify-content-between align-items-center totalcar">
                <h3>{count.TotalSoldcars}</h3>
                <img src="assets/images/car-sold12.png" alt="" />
              </div>
            </div>
          </Link>
          <Link to={"/Soldunsold"} state={{ status: "Unsold" }}>
            <div className="dash-block ">
              <span>Unsold vehicles</span>
              <div className="d-flex justify-content-between align-items-center totalcar">
                <h3>{count.TotalUnsoldcars}</h3>
                <img src="assets/images/car-unsold12.png" alt="" />
              </div>
            </div>
          </Link>
          <Link to={"/soldunsoldthismonth"} state={{ status: "Sold" }}>
            <div className="dash-block ">
              <span>
                Sold <br /> This Month
              </span>

              <div className="d-flex justify-content-between align-items-center totalcar">
                <h3>{count.SoldCarbymonth}</h3>
                <img src="assets/images/car12.png" alt="" />
              </div>
            </div>
          </Link>
          <Link to={"/soldunsoldthismonth"} state={{ status: "Bought" }}>
            <div className="dash-block">
              <span>
                Purchased <br /> This Month
              </span>
              <div className="d-flex justify-content-between align-items-center totalcar">
                <h3>{count.BoughtCarbymonth}</h3>

                <img src="assets/images/car12.png" alt="" />
              </div>
            </div>
          </Link>

          <div className="text-center">
            <button
              onClick={() => {
                iphone
                  ? shareIphonePostMsg({
                      url: "https://www.facebook.com/carthi.india",
                      action: "open_url_linking",
                    })
                  : window.open(
                      "https://www.facebook.com/carthi.india",
                      "_blank",
                      "noopener,noreferrer",
                    );
              }}
              rel="noreferrer"
              className="home-social facebook"
            >
              <img src="assets/images/facebook.svg" alt="" />
              carthiofficial
            </button>
          </div>

          <div className="text-center">
            <button
              onClick={() => {
                iphone
                  ? shareIphonePostMsg({
                      url: "https://www.instagram.com/carthi.india",
                      action: "open_url_linking",
                    })
                  : window.open(
                      "https://www.instagram.com/carthi.india",
                      "_blank",
                      "noopener,noreferrer",
                    );
              }}
              rel="noreferrer"
              className="home-social instagram"
            >
              <img src="assets/images/instagram.svg" alt="" />
              carthi_24
            </button>
          </div>
        </div>

        {/* <div className="design-social">
          <Link to={"/MakeCustomizepost"} className="home-social design d-flex">
            <img src="assets/images/design-template.png" alt="" />
            <span className="flex-grow-1">
              <p>Design your Facebook & Instagram post for marketing.</p>
            </span>
          </Link>
        </div> */}

        {Dealerdata.nPostpermission === "Allow" ? null : (
          <div className="cat-link">
            <div>
              <h3 className="mb-2">Autopost your car on Carthi pages </h3>
              <span>
                Allow Carthi to share your car catalog on Facebook and Instagram
                to reach a wider audience. Reply 'Allow' to proceed or 'Deny' to
                opt out."
              </span>
            </div>

            <div className="d-flex justify-content-center mt-2">
              <Button
                className="ms-2"
                bgColor="green"
                id="Allow"
                onClick={(e) => permissionallowed("Allow")}
              >
                Allow
              </Button>
              <Button
                className="ms-2"
                bgColor="#ed1c24"
                id="Deny"
                onClick={(e) => permissionallowed("Not Allow")}
              >
                Deny
              </Button>
            </div>
          </div>
        )}
        <div className="cat-link d-block">
          <div className="service-grid">
            <Link to="/CheckRC">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/cartest.png" alt="" />
                <label className="text-center">RC Search</label>
              </div>
            </Link>
            <Link to="https://echallan.parivahan.gov.in/index/accused-challan#challan_list">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/receipt.png" alt="" />
                <label className="text-center">Check Challan</label>
              </div>
            </Link>
            <Link to="/CreateStatus">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/status12.png" alt="" />
                <label className="text-center">Create Status</label>
              </div>
            </Link>
            <Link to="/SearchmoreCars">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/tradetest.png" alt="" />
                <label className="text-center">Dealer Market</label>
              </div>
            </Link>
            <Link to="/LoanEmi">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/tax-calculate.png" alt="" />
                <label className="text-center">EMI Calculator</label>
              </div>
            </Link>
            <Link to="/MessageTemplate">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/emailtest.png" alt="" />

                <label className="text-center">Message Template</label>
              </div>
            </Link>{" "}
            <Link to="/Carstationary">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/carlist.png" alt="" />
                <label className="text-center">Car Stationary</label>
              </div>
            </Link>
            <Link to="/Updatedcarprice">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/carprice.png" alt="" />
                <label className="text-center">New Pricelist</label>
              </div>
            </Link>
          </div>
          {/* <div className="service-grid">
            <Link to="/CheckRC">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/cartest.png" alt="" />
                <label className="text-center">RC Search</label>
              </div>
            </Link>
            <Link to="https://echallan.parivahan.gov.in/index/accused-challan#challan_list">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/receipt.png" alt="" />
                <label className="text-center">Check Challan</label>
              </div>
            </Link>
            <Link to="/CreateStatus">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/status12.png" alt="" />
                <label className="text-center">Create Status</label>
              </div>
            </Link>
            <Link to="/SearchmoreCars">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/tradetest.png" alt="" />
                <label className="text-center">Dealer Market</label>
              </div>
            </Link>
            <Link to="/LoanEmi">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/tax-calculate.png" alt="" />
                <label className="text-center">EMI Calculator</label>
              </div>
            </Link>
            <Link to="/MessageTemplate">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/emailtest.png" alt="" />

                <label className="text-center">Message Template</label>
              </div>
            </Link>{" "}
            <Link to="/Carstationary">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/carlist.png" alt="" />
                <label className="text-center">Car Stationary</label>
              </div>
            </Link>
            <Link to="/Updatedcarprice">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <img src="assets/images/carprice.png" alt="" />
                <label className="text-center">New Pricelist</label>
              </div>
            </Link>
          </div> */}
        </div>
        {/* <div className="design-social "> */}
        {/* <Link to={"/"} className="home-social design d-flex">
            <img src="assets/images/design-template.png" alt="" />
            <p
              style={{
                position: "absolute",
                left: "50% !important",
                transform: "translate(-50%,-50%)",
                top: "50%",
                margin: 0,
              }}
            >
              Cars from customer
            </p>
          </Link> */}

        {/* </div> */}

        <div
          className="cat-link"
          style={{ justifyContent: "center", flexDirection: "column" }}
        >
          {/* <div>
            <h3>Your catalogue link :</h3>
            <span>
              https://m.carthi.in/#/Catlogueshare/
              {localStorage.getItem("Ca1itd")}/
              {localStorage.getItem("Ca1nioamed")?.replace(/[,& . ']/g, "")}
            </span>
          </div> */}
          <div className="d-flex align-items-center justify-content-center">
            <img src={Dealerdata?.Logo} alt="" height={40} className="me-2" />
            <h3>{Dealerdata?.Firmname}</h3>
          </div>

          <div className="d-flex justify-content-center mt-2">
            {iphone ? (
              <button
                className="sharebtn"
                onClick={() => {
                  shareIphonePostMsg({
                    url:
                      "https://m.carthi.in/#/Catlogueshare/" +
                      localStorage.getItem("Ca1itd") +
                      "/" +
                      localStorage.getItem("Ca1nioamed"),
                    title: localStorage.getItem("Ca1nioamed"),
                    action: "urlshare",
                  });
                }}
              >
                Share catalog
                <span>
                  <img src="assets/images/share.png" alt="" />
                </span>
              </button>
            ) : (
              <RWebShare
                data={{
                  text: localStorage.getItem("Ca1nioamed") || "Car Portfolio",
                  url:
                    "https://m.carthi.in/#/Catlogueshare/" +
                    localStorage.getItem("Ca1itd") +
                    "/" +
                    localStorage.getItem("Ca1nioamed"),
                  title: localStorage.getItem("Ca1nioamed") || "Car Portfolio",
                }}
                onClick={() => console.log("shared successfully!")}
              >
                <button className="sharebtn">
                  Share catalog
                  <span>
                    <img src="assets/images/share.png" alt="" />
                  </span>
                </button>
              </RWebShare>
            )}

            <button className="sharebtn ms-2" onClick={(e) => onShare()}>
              Share to Number
              <span>
                <img src="assets/images/share.png" alt="" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <Profilerequired open={show} closehandler={(e) => closemodel()} />
      {/* <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe 
        src="https://m.anchoredge.in"
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="External Website"
      />
    </div> */}
    </div>
  );
});

export default Dashboard;

// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import Header from "./Header";
// import {
//   Userlogin,
//   GetDealerdata,
//   fetchDataFromApi,
//   shareIphonePostMsg,
// } from "./Utils/general-function";
// import { useNavigate, Link } from "react-router-dom";
// import Loader from "./Utils/Loader";
// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import { RWebShare } from "react-web-share";
// import styled from "styled-components";
// import Profilerequired from "./Account/profilerequired";
// //import { Tile } from "@tensorflow/tfjs";
// // import { UserProfile ,ApiProvider} from "./ApiContext";

// // const Body = styled.body`
// //   background: linear-gradient(180deg, rgb(255, 94, 94) 0%, rgb(255, 0, 0) 40%, rgb(0, 0, 0);
// //   min-height: 100dvh;
// // `;
// const Button = styled.button`
//   display: inline-block;
//   font-weight: 400;
//   line-height: 1.5;
//   text-align: center;
//   border-radius: 4px;
//   font-family: "Rubik", sans-serif;
//   padding: 3px 22px;
//   font-size: 1rem;
//   color: white;
//   user-select: none;
//   border: none;
//   background-color: ${(props) => props.bgColor || "red"};
// `;
// const Dashboard = React.memo((props) => {
//   const [loading, setLoading] = useState(true);
//   const [show, setShow] = useState(false);
//   const [Banner, setBanner] = useState([]);
//   const [count, setCount] = useState({
//     Totalcars: 0,
//     TotalUnsoldcars: 0,
//     TotalSoldcars: 0,
//     TotalCatelogecar: 0,
//     TotalCarinCateloge: 0,
//     UpdateNotification: [],
//   });
//   const [Dealerdata, setDealerdata] = useState({});
//   // const { apiData,updateUserProfile } = UserProfile();
//   const navigate = useNavigate();
//   const iphone = window.navigator.userAgent.includes("Mac");
//   useEffect(() => {
//     // document.documentElement.lang = "fr";
//     const fetchData = async () => {
//       const loadScript = () => {
//         return new Promise((resolve, reject) => {
//           const existingScript = document.getElementById("gravitec-script");
//           if (existingScript) {
//             resolve(); // Script is already loaded
//             return;
//           }

//           const script = document.createElement("script");
//           script.src =
//             "https://cdn.gravitec.net/storage/6504ce9788418d04e4fd16f071126219/client.js";
//           script.async = true;
//           script.id = "gravitec-script";
//           script.onload = resolve;
//           script.onerror = reject;
//           document.head.appendChild(script);
//         });
//       };

//       try {
//         if (!Userlogin()) {
//           navigate("/Login");
//           return;
//         }

//         //  document.body.style.background = 'linear-gradient(0deg, rgb(254,0,0) 0%, rgb(0,0,0) 100%)';

//         const Dealerdata = await GetDealerdata();
//         setDealerdata(Dealerdata);

//         //   permissiontoggeled(Dealerdata.nPostpermission);
//         localStorage.setItem("Permission", Dealerdata.nPostpermission);

//         if (Dealerdata.nCity === "") {
//           setShow(true);
//         }

//         // Fetching dashboard data
//         const dashboardData =
//           (await fetchDataFromApi("/api/Carmaster/Dashboardcounter")) || [];
//         const count = {
//           TotalCatelogecar: dashboardData.Data.TotalCatelogecar,
//           TotalSoldcars: dashboardData.Data.TotalSoldcars,
//           TotalUnsoldcars: dashboardData.Data.TotalUnsoldcars,
//           Totalcars: dashboardData.Data.Totalcars,
//           TotalCarinCateloge: dashboardData.Data.TotalCarinCateloge,
//           UpdateNotification: dashboardData.Data.UpdatedNotificationlist,
//         };
//         setCount(count);

//         // Fetch banner data
//         const bannerData = await fetchDataFromApi(
//           "/api/Bannermaster/AllBanner"
//         );
//         setBanner(bannerData.Data);
//         // For Notification
//         await loadScript();

//         setLoading(false);
//       } catch (error) {
//         console.error("An error occurred:", error);
//         setLoading(false);
//       }
//     };

//     fetchData();

//     return () => {
//       const script = document.getElementById("gravitec-script");
//       //   document.body.style.background = '';
//       if (script) {
//         document.head.removeChild(script);
//       }
//     };
//   }, [navigate]);

//   const onShare = () => {
//     confirmAlert({
//       customUI: ({ onClose }) => {
//         let value = "";

//         return (
//           <div className="popup-overlay px-3 py-3">
//             <div className="form-div">
//               <label className="form-label">Mobile Number</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="mobileno"
//                 onChange={(e) => {
//                   value = e.target.value;
//                 }}
//               />
//               {/* <span className="text-danger">{errors.name}</span> */}
//             </div>
//             <button
//               className="submitbtn me-2 popup-btn"
//               onClick={() => {
//                 if (value !== "") {
//                   const text = encodeURIComponent(
//                     "https://m.carthi.in/#/Catlogueshare/" +
//                       localStorage.getItem("Ca1itd") +
//                       "/" +
//                       encodeURIComponent(
//                         localStorage
//                           .getItem("Ca1nioamed")
//                           ?.replace(/[,& . ']/g, "")
//                       )
//                   );

//                   if (iphone) {
//                     //return window.location.href = `https://wa.me/+91${value}?text=${text}`;

//                     shareIphonePostMsg({
//                       action: "open_url_linking",
//                       url: `https://wa.me/+91${value}?text=${text}`,
//                     });
//                   } else {
//                     // only work in android phone
//                     window.location.href = `intent://send?phone=+91${value}&text=${text}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;end`;
//                   }
//                   onClose();
//                 }
//               }}
//             >
//               Send
//             </button>
//             {/* <button
//               className="submitbtn me-2 popup-btn"
//               onClick={() => {
//                 onClose();
//               }}
//             >
//               No
//             </button> */}
//           </div>
//         );
//       },
//     });
//   };

//   const closemodel = () => {
//     setShow(!show);
//   };

//   const permissiontoggeled = (status) => {
//     const YesButton = document.getElementById("Allow");
//     const NoButton = document.getElementById("Deny");
//     if (status === "Allow") {
//       YesButton.textContent = "Allowed";
//       NoButton.textContent = "Deny";
//     } else {
//       // NoButton.textContent = "Denied";
//       YesButton.textContent = "Allow";
//     }
//   };

//   const permissionallowed = async (status) => {
//     // social media car share permission
//     const header = {
//       headers: {
//         Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//       },
//     };
//     const Response = await fetch(
//       process.env.REACT_APP_API_ENDPOINT +
//         "/api/BrandingProfile/UpdatePostPermission?postpermission=" +
//         status,
//       header
//     );
//     const Permission = await Response.json();
//     if (Permission.Success) {
//       localStorage.setItem("Permission", status);
//       permissiontoggeled(status);
//     }
//   };

//   const Poster = {
//     infinite: true,
//     slidesToScroll: 1,
//     dots: false,
//     arrows: false,
//     slidesToShow: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     swipeToSlide: true,
//     cssEase: "linear",
//   };

//   return (
//     <div>
//       <Header />
//       {loading ? <Loader /> : null}
//       <div className="slider-section">
//         <div className="slider-images">
//           <Slider {...Poster}>
//             {Banner.map((data) => (
//               <Link to={data.nUrl} key={data.nPhoto}>
//                 <img src={data.nPhoto} alt="" />
//               </Link>
//             ))}
//           </Slider>
//         </div>
//       </div>
//       {count.UpdateNotification.length !== 0 && (
//         <div className="latestbg">
//           <marquee>
//             {count.UpdateNotification.map((data) => (
//               <div className="latestnews" key={data.nTitle}>
//                 <Link to="/AllUpdatedNotification">{data.nTitle}</Link>
//               </div>
//             ))}
//           </marquee>
//         </div>
//       )}
//       {/* className="restpart"=> class for festival */}
//       <div>
//         <div className="dash-grid">
//           <Link to="/MyCar">
//             <div className="dash-block ">
//               <span>My vehicles</span>
//               <div className="d-flex justify-content-between align-items-center totalcar">
//                 <h3>{count.Totalcars}</h3>
//                 <img src="assets/images/car12.png" alt="" />
//               </div>
//             </div>
//           </Link>
//           <Link to={"/Catlogue/" + localStorage.getItem("Ca1itd")}>
//             <div className="dash-block ">
//               <span>My catalogue</span>
//               <div className="d-flex justify-content-between align-items-center totalcar">
//                 <h3>{count.TotalCatelogecar}</h3>
//                 <img src="assets/images/catalogue12.png" alt="" />
//               </div>
//             </div>
//           </Link>
//           <Link to={"/Soldunsold"} state={{ status: "Sold" }}>
//             <div className="dash-block ">
//               <span>Sold vehicles</span>
//               <div className="d-flex justify-content-between align-items-center totalcar">
//                 <h3>{count.TotalSoldcars}</h3>
//                 <img src="assets/images/car-sold12.png" alt="" />
//               </div>
//             </div>
//           </Link>
//           <Link to={"/Soldunsold"} state={{ status: "Unsold" }}>
//             <div className="dash-block ">
//               <span>Unsold vehicles</span>
//               <div className="d-flex justify-content-between align-items-center totalcar">
//                 <h3>{count.TotalUnsoldcars}</h3>
//                 <img src="assets/images/car-unsold12.png" alt="" />
//               </div>
//             </div>
//           </Link>
//           {/* <div className="text-center">
//             <Link
//               to={"https://www.facebook.com/carthi.india"}
//               target="_blank"
//               rel="noreferrer"
//               className="home-social facebook"
//             >
//               <img src="assets/images/facebook.svg" alt="" />
//               carthiofficial
//             </Link>
//           </div> */}
//           <div className="text-center">
//             <button
//               onClick={() => {
//                 iphone
//                   ? shareIphonePostMsg({
//                       url: "https://www.facebook.com/carthi.india",
//                       action: "open_url_linking",
//                     })
//                   : window.open(
//                       "https://www.facebook.com/carthi.india",
//                       "_blank",
//                       "noopener,noreferrer"
//                     );
//               }}
//               rel="noreferrer"
//               className="home-social facebook"
//             >
//               <img src="assets/images/facebook.svg" alt="" />
//               carthiofficial
//             </button>
//           </div>
//           {/* <div className="text-center">
//             <Link
//               to={"https://www.instagram.com/carthi.india"}
//               target="_blank"
//               rel="noreferrer"
//               className="home-social instagram"
//             >
//               <img src="assets/images/instagram.svg" alt="" />
//               carthi_24
//             </Link>
//           </div> */}
//           <div className="text-center">
//             <button
//               onClick={() => {
//                 iphone
//                   ? shareIphonePostMsg({
//                       url: "https://www.instagram.com/carthi.india",
//                       action: "open_url_linking",
//                     })
//                   : window.open(
//                       "https://www.instagram.com/carthi.india",
//                       "_blank",
//                       "noopener,noreferrer"
//                     );
//               }}
//               rel="noreferrer"
//               className="home-social instagram"
//             >
//               <img src="assets/images/instagram.svg" alt="" />
//               carthi_24
//             </button>
//           </div>
//         </div>

//         <div className="design-social">
//           <Link to={"/MakeCustomizepost"} className="home-social design d-flex">
//             <img src="assets/images/design-template.png" alt="" />
//             <span className="flex-grow-1">
//               <p>Design your Facebook & Instagram post for marketing.</p>
//             </span>
//           </Link>
//         </div>

//         {Dealerdata.nPostpermission === "Allow" ? null : (
//           <div className="cat-link">
//             <div>
//               <h3 className="mb-2">Autopost your car on Carthi pages </h3>
//               <span>
//                 Allow Carthi to share your car catalog on Facebook and Instagram
//                 to reach a wider audience. Reply 'Allow' to proceed or 'Deny' to
//                 opt out."
//               </span>
//             </div>

//             <div className="d-flex justify-content-center mt-2">
//               <Button
//                 className="ms-2"
//                 bgColor="green"
//                 id="Allow"
//                 onClick={(e) => permissionallowed("Allow")}
//               >
//                 Allow
//               </Button>
//               <Button
//                 className="ms-2"
//                 bgColor="#ed1c24"
//                 id="Deny"
//                 onClick={(e) => permissionallowed("Not Allow")}
//               >
//                 Deny
//               </Button>
//             </div>
//           </div>
//         )}
//         <div className="cat-link d-block">
//           <div className="service-grid">
//             <Link to="/CheckRC">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/cartest.png" alt="" />
//                 <label className="text-center">RC Search</label>
//               </div>
//             </Link>
//             <Link to="https://echallan.parivahan.gov.in/index/accused-challan#challan_list">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/receipt.png" alt="" />
//                 <label className="text-center">Check Challan</label>
//               </div>
//             </Link>
//             <Link to="/CreateStatus">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/status12.png" alt="" />
//                 <label className="text-center">Create Status</label>
//               </div>
//             </Link>
//             <Link to="/SearchmoreCars">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/tradetest.png" alt="" />
//                 <label className="text-center">Dealer Market</label>
//               </div>
//             </Link>
//             <Link to="/LoanEmi">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/tax-calculate.png" alt="" />
//                 <label className="text-center">EMI Calculator</label>
//               </div>
//             </Link>
//             <Link to="/MessageTemplate">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/emailtest.png" alt="" />

//                 <label className="text-center">Message Template</label>
//               </div>
//             </Link>{" "}
//             <Link to="/Carstationary">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/carlist.png" alt="" />
//                 <label className="text-center">Car Stationary</label>
//               </div>
//             </Link>
//             <Link to="/Updatedcarprice">
//               <div className="d-flex justify-content-center align-items-center flex-column">
//                 <img src="assets/images/carprice.png" alt="" />
//                 <label className="text-center">New Pricelist</label>
//               </div>
//             </Link>
//           </div>
//         </div>

//         <div className="cat-link">
//           <div>
//             <h3>Your catalogue link :</h3>
//             <span>
//               https://m.carthi.in/#/Catlogueshare/
//               {localStorage.getItem("Ca1itd")}/
//               {localStorage.getItem("Ca1nioamed")?.replace(/[,& . ']/g, "")}
//             </span>
//           </div>

//           <div className="d-flex justify-content-center mt-2">
//             {iphone ? (
//               <button
//                 className="sharebtn"
//                 onClick={() => {
//                   shareIphonePostMsg({
//                     url:
//                       "https://m.carthi.in/#/Catlogueshare/" +
//                       localStorage.getItem("Ca1itd") +
//                       "/" +
//                       localStorage.getItem("Ca1nioamed"),
//                     title: localStorage.getItem("Ca1nioamed"),
//                     action: "urlshare",
//                   });
//                 }}
//               >
//                 Share catalogue
//                 <span>
//                   <img src="assets/images/share.png" alt="" />
//                 </span>
//               </button>
//             ) : (
//               <RWebShare
//                 data={{
//                   text: localStorage.getItem("Ca1nioamed") || "Car Portfolio",
//                   url:
//                     "https://m.carthi.in/#/Catlogueshare/" +
//                     localStorage.getItem("Ca1itd") +
//                     "/" +
//                     localStorage.getItem("Ca1nioamed"),
//                   title: localStorage.getItem("Ca1nioamed") || "Car Portfolio",
//                 }}
//                 onClick={() => console.log("shared successfully!")}
//               >
//                 <button className="sharebtn">
//                   Share catalogue
//                   <span>
//                     <img src="assets/images/share.png" alt="" />
//                   </span>
//                 </button>
//               </RWebShare>
//             )}

//             <button className="sharebtn ms-2" onClick={(e) => onShare()}>
//               Share to Number
//               <span>
//                 <img src="assets/images/share.png" alt="" />
//               </span>
//             </button>
//           </div>
//         </div>
//       </div>

//       <Profilerequired open={show} closehandler={(e) => closemodel()} />
//       {/* <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
//       <iframe
//         src="https://m.anchoredge.in"
//         style={{ width: '100%', height: '100%', border: 'none' }}
//         title="External Website"
//       />
//     </div> */}
//     </div>
//   );
// });

// export default Dashboard;
